// extracted by mini-css-extract-plugin
export default {"title":"title_wlaT3","jump":"jump_SybLh","alert":"alert_kUwVD","btn":"btn_uCbQR"};